export default (to, from, next) => {
  // if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
  //   next()
  // } else {
  //   localStorage.removeItem('currentUser')
  //   next('/auth/login')
  // }
  next()
}
